module.exports = __webpack_public_path__ + "img/62456709df3e17415c6e2751d25f28a.1386ef72.png";